(() => {
  'use strict';
  function setup(root = document) {
    root.querySelectorAll('[data-mistura-purchase]').forEach(form => {
      if (form.dataset.commerceReady) return;
      form.dataset.commerceReady = 'true';
      const data = JSON.parse(form.querySelector('[data-purchase-data]').textContent);
      const variantInput = form.querySelector('[name="id"]');
      const planSelect = form.querySelector('[data-selling-plan]');
      const schedule = form.querySelector('.mf-subscription-schedule');
      const subscribe = form.querySelector('[value="subscribe"]');
      const once = form.querySelector('[value="once"]');
      const price = form.querySelector('[data-purchase-price]');
      const button = form.querySelector('[type="submit"]');
      const note = form.querySelector('[data-shipping-note]');
      function sync() {
        const variant = data.variants.find(item => String(item.id) === variantInput.value);
        if (!variant) { button.disabled = true; return; }
        const oldPlan = planSelect?.value;
        if (planSelect) {
          planSelect.replaceChildren(...variant.plans.map(plan => {
            const option = document.createElement('option');
            option.value = String(plan.id);
            option.textContent = plan.name + ' · ' + plan.price;
            return option;
          }));
          if (variant.plans.some(plan => String(plan.id) === oldPlan)) planSelect.value = oldPlan;
          if (!variant.plans.length) once.checked = true;
          subscribe.disabled = !variant.plans.length;
          form.querySelector('[data-subscribe-choice]').hidden = !variant.plans.length;
          const subscribing = subscribe.checked && variant.plans.length > 0;
          schedule.hidden = !subscribing;
          planSelect.disabled = !subscribing;
        }
        const selectedPlan = subscribe?.checked ? variant.plans.find(plan => String(plan.id) === planSelect.value) : null;
        price.textContent = selectedPlan?.price || variant.price;
        note.textContent = (selectedPlan?.cents ?? variant.cents) >= 3499 ? data.shippingFree : data.shippingBelow;
        button.disabled = !variant.available;
      }
      form.addEventListener('mistura:variant-change', sync);
      form.querySelectorAll('[name="purchase_type"]').forEach(input => input.addEventListener('change', sync));
      planSelect?.addEventListener('change', sync);
      sync();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
